import "~/styles/globals.css";
import "urlpattern-polyfill";

import { ProgressProvider } from "@bprogress/next/pages";
import { DefaultSeo } from "next-seo";
import { NuqsAdapter } from "nuqs/adapters/next/pages";

import AppErrorBoundary from "~/components/AppErrorBoundary";
import ChatWidget from "~/components/Chat/ChatWidget";
import PageConfig from "~/components/PageConfig";
import Providers from "~/components/Providers";
import Scripts from "~/components/Scripts";
import { PrimaryLayout } from "~/layouts";
import SEO from "~/seo.config";
import type { CustomAppProps } from "~/types";
import { font } from "~/utils/constants";

const App = (props: CustomAppProps) => {
	const { pageProps, Component } = props;
	const Layout = Component.Layout ?? PrimaryLayout;

	return (
		<div className={font.className}>
			<DefaultSeo {...SEO} />
			<Scripts />

			<Providers>
				<NuqsAdapter>
					<ProgressProvider
						color="var(--color-loader)"
						options={{ showSpinner: false }}
					>
						<PageConfig {...props}>
							<Layout {...pageProps}>
								<AppErrorBoundary
									route={props.router.pathname}
									path={props.router.asPath}
								>
									<Component {...pageProps} />
								</AppErrorBoundary>
							</Layout>
						</PageConfig>
					</ProgressProvider>
					<ChatWidget />
				</NuqsAdapter>
			</Providers>
		</div>
	);
};

export default App;
